import {
  ICategoriesState,
  ICategory,
} from 'Context/CompassRightsContext/EntitlementsProvider';
import { sessionCategoriesFilter } from './EntitlementsReducer';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

export function CategoriesFilterReducer(state: any, action: any) {
  switch (action.type) {
    case 'INITIALIZATION': {
      const categoryFilter = sessionStorage.getItem(sessionCategoriesFilter);
      if (categoryFilter) {
        const updatedCategories = JSON.parse(categoryFilter);
        return updatedCategories;
      }
      const { value: categories } = action.payload;
      const updatedCategories = categories.map(
        (category: ICategoriesState) => ({
          ...category,
          checked: false,
          subCategories: category.subCategories?.map(
            (subCategory: ICategory) => ({
              ...subCategory,
              checked: false,
            })
          ),
        })
      );
      updatedCategories.forEach((category: ICategoriesState) => {
        category.subCategories.unshift({
          id: 0,
          name: Dictionary[DICTIONARY.CompassRights].everything,
          checked: false,
        });
      });
      return updatedCategories;
    }
    case 'FILTER_CHECKBOX': {
      return CheckboxFilterManager(
        [...state],
        action.payload.value.mainCat,
        action.payload.value.subCat
      );
    }
    case 'REMOVE_SINGLE_SUB_CATEGORY': {
      return RemoveSingleFilter([...state], action.payload.value);
    }
    case 'RESET': {
      return state.map((category: ICategoriesState) => ({
        ...category,
        checked: false,
        subCategories: category.subCategories?.map(
          (subCategory: ICategory) => ({
            ...subCategory,
            checked: false,
          })
        ),
      }));
    }
  }
  return state;
}

/**
 * For a given main category and sub category changes the checked state.
 * @param categories Categories list.
 * @param mainCatID MainCategory ID number
 * @param subCatID SubCategory ID number
 * @returns Categories list.
 */
function CheckboxFilterManager(
  categories: any,
  mainCatID: number,
  subCatID: Array<number>
) {
  const category: ICategoriesState = categories.find(
    (category: ICategoriesState) => category.id === mainCatID
  );

  if (subCatID.includes(0)) {
    if (category.id === mainCatID) {
      category.subCategories.forEach(
        (subCat: ICategory) => (subCat.checked = true)
      );
    }
    if (subCatID.length === category.subCategories.length - 1) {
      category.subCategories.forEach((subCat: ICategory) => {
        if (subCatID.includes(subCat.id)) subCat.checked = true;
        else subCat.checked = false;
      });
      category.subCategories[0].checked = false;
    }
    return categories;
  }

  if (
    !subCatID.includes(0) &&
    category.subCategories.length - 1 ===
      category.subCategories.filter(
        (subCat: ICategory) => subCat.checked && subCat.id !== 0
      ).length
  ) {
    category.subCategories.forEach((subCat: ICategory) => {
      subCat.checked = false;
    });
    return categories;
  }

  if (category.id === mainCatID) {
    category.subCategories.forEach((subCat: ICategory) => {
      if (subCatID.includes(subCat.id)) subCat.checked = true;
      else subCat.checked = false;
    });
    if (
      category.subCategories.length - 1 ===
      category.subCategories.filter(
        (subCat: ICategory) => subCat.checked && subCat.id !== 0
      ).length
    )
      category.subCategories[0].checked = true;
    else category.subCategories[0].checked = false;
  }
  return categories;
}

/**
 * Given a subCategory ID changes the checked status to false.
 * @param categories Categories list.
 * @param categoriesID Category ID
 * @returns Categories list.
 */
function RemoveSingleFilter(
  categories: any,
  categoriesID: { mainCategoryID: number; subCategoryID: number }
) {
  const category = categories.find(
    ({ id }: { id: number }) => id === categoriesID.mainCategoryID
  );
  if (category) {
    const subCategory = category.subCategories.find(
      ({ id }: { id: number }) => id === categoriesID.subCategoryID
    );
    if (subCategory) subCategory.checked = false;
  }

  return categories;
}
